import Btn from '@components/Btn';
import { useEffect } from 'react';
import {
	HIDE_OVERVIEW_BUTTON,
	HOME_BUTTON_THREE_TEXT,
	WALLED_GARDEN,
	HP_ANIMATIONS,
	HP_ANIMATION_TYPE,
} from '@lib/constants';
import { trackUsageClick } from '@lib/helpers/reporting';
import { useRouter } from 'next/router';

import { staggerAnimations } from '@lib/helpers';
import { initTriggeredAnimations } from '@lib/helpers/blockAnimations';

export default function OverviewButton({ classes = [], isAdvisor = false }) {
	const router = useRouter();

	const handleClick = () => {
		trackUsageClick('overview');
		router.push('/overview');
	};

	const animationClass = HP_ANIMATIONS && HP_ANIMATION_TYPE
	? `animate ${HP_ANIMATION_TYPE} hp-has-triggered-animation`
	: '';

	const mergedClasses = [
		'outline',
		'mb-0',
		'outline--home',
		animationClass,
		...(classes || [])
	];

	const animationData =
	HP_ANIMATIONS && HP_ANIMATION_TYPE
		? {
				'data-hp-trigger-selector': '',
				'data-hp-triggered-animation':
					HP_ANIMATION_TYPE,
				'data-hp-trigger-event':
					'viewport',
				'data-hp-triggered-played' : '0',
			}
		: {};

	useEffect(() => {
		staggerAnimations();
		initTriggeredAnimations();
	}, []);

	if (isAdvisor) {
		return (
			<Btn onClick={handleClick} customClass={mergedClasses} {...animationData}>
				{HOME_BUTTON_THREE_TEXT}
			</Btn>
		);
	}

	if (HIDE_OVERVIEW_BUTTON) {
		return;
	}

	if (WALLED_GARDEN) {
		return;
	}

	return (
		<Btn onClick={handleClick} customClass={mergedClasses} {...animationData}>
			{HOME_BUTTON_THREE_TEXT}
		</Btn>
	);
}
